import classes from './ShowPage.module.css';

const ShowPage = () => {
  return (
      <div className={classes["show-background"]}>
      </div>
  );
}

export default ShowPage;